import { SearchSection } from './SearchSection'
import { withSearchSection } from './withSearchSection'

const ConnectedSearchSection = withSearchSection(SearchSection)

export { ConnectedSearchSection as SearchSection }
